export const  GET_Product_Load="ADD_Product_Load"
export const  GET_Product_Success="GET_Product_Success"
export const  GET_Product_Error="DELETE_Product_Error"
export const GET_Single_Product="GET_Single_Product"
